import {
  IProduct,
  ListProductsResponse
} from "src/core/products/api/products.api";
import { IProductSubstitution } from "src/modules/substitutions/api/substitutions.api";

export interface IProductMaybeWithSubstitution extends IProduct {
  substitution?: IProductSubstitution;
}

const filterProductSubstitutions = (productsResponse: ListProductsResponse | null): IProductMaybeWithSubstitution[] => {
  const { result: productData, substitutions } = productsResponse || {};

  if (!productData) {
    return [];
  }

  if (!substitutions) {
    return productData;
  }

  // clone products
  const productsWithSubstitutions: IProductMaybeWithSubstitution[] = [ ...productData ];

  // for each substititon
  for (const substitution of substitutions) {
    // find replacement product
    const substituteProductIndex = productsWithSubstitutions.findIndex(product => product.id === substitution.previousProductId);

    // add replaced product info to substitute

    productsWithSubstitutions[ substituteProductIndex ].substitution = substitution;
  }

  return productsWithSubstitutions;
};

export default filterProductSubstitutions;
